import { APIEntityType } from '@ardoq/api-types';
import type { FieldValueScopeSource } from '@ardoq/data-model';
import {
  FieldValuesCache,
  fieldValuesCache,
  getFieldSortedValues,
} from './FieldValuesCache';

// TODO(typeName-migration): Remove affectsTypeName; use affectsTypeNames directly
// in buildCacheKey/getFieldSortedValues below.
export const resolveFieldSortedValuesFromCache = (
  scopeSource: FieldValueScopeSource | null,
  filterAttributeName: string,
  entityType: APIEntityType.COMPONENT | APIEntityType.REFERENCE,
  affectsTypeName: string | undefined,
  affectsTypeNames: string[] | undefined
): number[] | null => {
  if (!scopeSource) {
    return null;
  }
  const cacheKey = FieldValuesCache.buildCacheKey(
    filterAttributeName,
    entityType,
    affectsTypeName,
    affectsTypeNames
  );
  if (!fieldValuesCache.has(scopeSource, cacheKey)) {
    fieldValuesCache.set(
      scopeSource,
      cacheKey,
      getFieldSortedValues({
        scopeSource,
        fieldName: filterAttributeName,
        entityType,
        affectsTypeName,
        affectsTypeNames,
      })
    );
  }
  return fieldValuesCache.get(scopeSource, cacheKey);
};
